<div #contentDiv class="max-w-lg mx-auto flex-col">
  <div class="h-20"></div>
  <div class="flex flex-col bg-theme-surface rounded-t-3xl min-h-[calc(100dvh-5rem)]">
    <!-- 1. Header -->
    <div class="flex flex-row pt-6 px-4 pb-4 items-center">
      <div class="ml-auto">
        <app-circle-button [icon]="'fa-close'" size="12" type="solid" fontSize="xl" (onClick)="cancel()"></app-circle-button>
      </div>
    </div>

    <!-- 2. Body -->
    <div class="flex-1 flex flex-col h-full items-center">
      <div *ngIf="payment" class="mt-16">
        <app-payment-card-title *ngIf="titleType==='card'" contrastTo="--theme-text"></app-payment-card-title>
        <app-payment-swish-title *ngIf="titleType==='swish'" contrastTo="--theme-text"></app-payment-swish-title>
        <app-payment-vipps-title *ngIf="titleType==='vipps'" contrastTo="--theme-text"></app-payment-vipps-title>
      </div>
      <div *ngIf="payment" class="text-lg font-bold mt-8 text-theme-text">{{amountFormatted}}</div>
      <div *ngIf="payment && swishQR" class="">
        <img [src]="swishQR">
      </div>
      <div class="mt-8" *ngIf="isLoading">
        <app-loading-spinner size="lg"></app-loading-spinner>
      </div>

      <div *ngIf="noticeSwishAuto && !payWithNumber" class="notice-swish-auto text-theme-text">
        <div class="inst">NOTIS!</div>
        <div class="inst">Swish kan inte längre öppnas automatiskt från messenger.</div>
        <div class="inst"><b>Välj betala med telefonnummer</b></div>
        <div class="inst">eller avbryt och betala med kort istället.</div>
        <div *ngIf="!showInfo" class="more_info"><a href="#" (click)="setShowInfo($event)">Mer info</a></div>
        <div *ngIf="showInfo">
          <div class="inst">Info:</div>
          <div class="inst">För närvarande kan vi inte öppna andra applikationer, som Swish, automatiskt från Messenger på iPhone. Detta är tyvärr en begränsning i Messenger-appen och inget som betalleverantören kan lösa.</div>
          <div class="inst">Vi rekommenderar att du istället använder webbversionen, som du når genom att skanna QR-koden.</div>
        </div>
      </div>

      <div *ngIf="payWithNumber" class="my-8 p-4 rounded-lg bg-theme-surface2 text-theme-text">
        <div class="inst">1. Öppna Swish-appen</div>
        <div class="inst">2. Genomför betalning</div>
        <div class="inst">3. Återgå till denna sida</div>
      </div>

      <div class="p-4 bg-theme text-theme-text rounded text-sm mt-auto mb-8" *ngIf="payment">
        <!-- Pesentkort -->
        <div class="env-panel px-4 pt-4 bg-primary rounded">
            <app-page-button *ngIf="payment.type==='swish' && !swishQR && !payWithNumber"
            [text]="getString('Betala med telefonnummer')" icon="fa-phone" (onClick)="showSwishPhone()"></app-page-button>
        </div>
        <div class="env-panel px-4 pt-4 bg-primary rounded">
          <app-page-button *ngIf="payment.type==='swish' && !swishQR && !payWithNumber"
          [text]="getString('Betala med annan enhet')" icon="fa-qrcode" (onClick)="showSwishQR()"></app-page-button>
        </div>
      </div>

      <div *ngIf="vivaDemoIssue" style="margin-top: 128px;;margin-bottom: 32px;">
        <button (click)="forceVivaTxCheck()">Tar längre tid än vanligt, kontrollera igen.</button>
      </div>
    </div>
  </div>

</div>
